import React, { useState } from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { useAuthentication } from "hooks";
import useExceptionHandler from "hooks/useExceptionHandler";
import ToolTip from "components/ToolTip/ToolTip";

export const ReturnCompanyButton = () => {
  const { volverCompaniaOriginal } = useAuthentication();
  const { handleException } = useExceptionHandler();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (loading) return;
    setLoading(true);
    volverCompaniaOriginal()
      .then(() => {
        window.location.reload();
      })
      .catch((e) => {
        handleException(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dropdown as={Nav.Item}>
      <Dropdown.Toggle
        as={Nav.Link}
        id="dropdown-return-company"
        className="buttonHover"
        onClick={handleClick}
      >
        <ToolTip placement="left" message="Volver a compañía principal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="#77777A"
            viewBox="0 0 24 24"
          >
            <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.222 18.917c5.666-5.905-.629-10.828-5.011-7.706l1.789 1.789h-6v-6l1.832 1.832c7.846-6.07 16.212 4.479 7.39 10.085z" />
          </svg>
        </ToolTip>
      </Dropdown.Toggle>
    </Dropdown>
  );
};
